import React from 'react';
import { Table, Empty, Button, Input, Checkbox, Form, Tooltip } from 'antd';

export default function Productos(props) {
    return (
        <div>
            <Table
                className={'table-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        title: 'Tipo de Comprobante',
                        dataIndex: 'tipoComprobante',
                        key: 'tipoComprobante',
                        align: 'center',
                        width: 65,
                        ellipsis: true,
                        render: (value, row) => (
                            <span>FACTURA ELECTRÓNICA</span>
                        )
                    },
                    {
                        title: 'Comprobante',
                        dataIndex: 'documentoSerie',
                        key: 'documentoSerie',
                        align: 'center',
                        width: 65,
                        ellipsis: true
                    },
             
                    {
                        title: 'Fecha Emisión',
                        dataIndex: 'fechaEmision',
                        key: 'fechaEmision',
                        align: 'center',
                        width: 65,
                        ellipsis: true
                    },
            
             
                    {
                        title: 'Moneda',
                        dataIndex: 'idMoneda',
                        key: 'idMoneda',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <span>{value==1?'PEN':'USD'}</span>
                        )
                    },
          
                    {
                        title: 'Importe Retención',
                        dataIndex: 'totalRetencion',
                        key: 'totalRetencion',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <span>{parseFloat(value).toFixed(2)}</span>

                        )
                    },
                    {
                        title: 'Importe Comprobante',
                        dataIndex: 'total',
                        key: 'total',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <span>{parseFloat(value).toFixed(2)}</span>

                        )
                    },
        

                    {
                        title: 'Importe Pagado',
                        dataIndex: 'totalPagado',
                        key: 'totalPagado',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <span>{parseFloat(value).toFixed(2)}</span>

                        )
                    },
            
                ]}
            />
        </div>
    );
}